import { addTermsAndConditionsAgreementStatus } from './api';

/**
 * 利用規約への同意状況を追加し、バージョンの一致を確認する関数
 * 
 * この関数は指定された名前とバージョンで利用規約への同意状況を記録し、
 * 記録されたバージョンが期待するバージョンと一致するかを検証します。
 * 
 * @param name - 利用規約の名前
 * @param version - 利用規約のバージョン
 * @returns バージョンが一致する場合はtrue、一致しない場合やエラー発生時はfalseを返すPromise
 * 
 * @example
 * ```typescript
 * const isAgreed = await addTermsAndConditionsAgreement("privacy-policy", "2.1");
 * if (isAgreed) {
 *   console.log("利用規約への同意が正常に記録されました");
 * }
 * ```
 */
export const addTermsAndConditionsAgreement = async (
    name: string,
    version: string
): Promise<boolean> => {
    try {
        const result = await addTermsAndConditionsAgreementStatus(name, version);
        return result.termsAndConditionsVersion === version;
    } catch {
        return false;
    }
};